import { downloadBlob } from '../utils';
import { getSvgExportPayload } from '../svg/extractSvg';
import { renderSvgToCanvas } from '../svg/renderSvgToCanvas';
import { ImageFormat } from '../enum';

export const exportImage = async (options: {
  container: HTMLElement | null;
  fileName: string;
  format: ImageFormat;
}) => {
  const payload = getSvgExportPayload(options.container);
  if (!payload) {
    return;
  }

  const canvas = await renderSvgToCanvas(payload.svgString, payload.width, payload.height);
  const PADDING = 16;
  const paddedCanvas = document.createElement('canvas');

  paddedCanvas.width = payload.width + PADDING * 2;
  paddedCanvas.height = payload.height + PADDING * 2;

  const paddedContext = paddedCanvas.getContext('2d');
  if (!paddedContext) {
    return;
  }

  paddedContext.fillStyle = '#ffffff';
  paddedContext.fillRect(0, 0, paddedCanvas.width, paddedCanvas.height);
  paddedContext.drawImage(canvas, PADDING, PADDING);

  const outputCanvas = paddedCanvas;
  const isPng = options.format === ImageFormat.Png;
  const mimeType = isPng ? 'image/png' : 'image/jpeg';
  const extension = isPng ? 'png' : 'jpg';

  let blob = await new Promise<Blob | null>((resolve) => {
    outputCanvas.toBlob(resolve, mimeType, options.format === ImageFormat.Jpeg ? 0.92 : undefined);
  });

  if (!blob) {
    blob = await fetch(outputCanvas.toDataURL(mimeType, options.format === ImageFormat.Jpeg ? 0.92 : undefined)).then(
      (res) => res.blob()
    );
  }

  if (!blob) {
    return;
  }

  downloadBlob(blob, `${options.fileName}.${extension}`);
};
